import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmCodeField from '../../../ReusableField/ConfirmCodeField'
import Button from '../../../UiKitComponents/Button'
import CountDown from '../../../ReusableField/CountDown/CountDown'
import {
  setUserEmail,
  setVerificationCode,
} from '../../../../redux/actions/authActions'
import styles from '../../../NestedComponents/Option 2/SettingsModals/settingsModals.module.scss'
import {
  emailVerification,
  resendEmailCode,
  upDateUserData,
} from '../../../../api/userApi'
import { closeConfirmationModal } from '../../../../redux/actions/confirmationModal'
import { setToastNotification } from '../../../../redux/actions/toastNotification'

const EnterCode = ({ emailEditValue }) => {
  const {
    userDetails: { email },
  } = useSelector((state) => state)
  const dispatch = useDispatch()
  const mlSeconds = 90000
  // const path = history.location.pathname.slice(1)
  const { verificationCode } = useSelector((state) => state.auth)
  const [errorMessage, setErrorMessage] = useState('')
  const [date, setDate] = useState(Date.now() + mlSeconds)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [verificationCode])

  const handleSubmit = () => {
    if (!verificationCode) {
      setErrorMessage('Bestätigungscode erforderlich')
      return
    }
    if (verificationCode.length !== 6) {
      setErrorMessage('smsCodeInvalid')
      return
    }
    const body = {
      verificationCode: verificationCode,
    }
    emailVerification(body)
      .then((res) => {
        emailEditValue ? dispatch(setUserEmail(emailEditValue)) : null
        dispatch(closeConfirmationModal())
      })
      .then(() => {
        dispatch(
          setToastNotification({
            type: 'success',
            toastTittle: '',
            toastBody: 'Ihre E-Mail wurde erfolgreich aktualisiert.',
          }),
        )
      })
      .catch((err) => {
        if (err.errorCode === 'REIMBURSEMENT_ACCOUNT_EMAIL_VERIFY_WRONG_CODE') {
          setErrorMessage('Der Bestätigungscode ist ungültig.')
          // console.log('Verification code is invalid.')
        }
      })
  }

  const handleResendCode = () => {
    const body = {
      emailAddress: emailEditValue,
    }
    upDateUserData(body)
      .then((res) => {
        emailEditValue ? dispatch(setUserEmail(emailEditValue)) : null
        dispatch(
          setToastNotification({
            type: 'success',
            toastBody:
              'Wir haben Ihnen einen neuen Code an Ihre E-Mail geschickt. Bitte prüfen Sie Ihr Postfach.',
          }),
        )
      })
      .catch((err) => {
        if (err.errorCode === 'REIMBURSEMENT_ACCOUNT_EMAIL_VERIFY_WRONG_CODE') {
          setErrorMessage('Der Bestätigungscode ist ungültig.')
        }
      })
  }

  const handleSetVerificationCode = (value) => {
    dispatch(setVerificationCode(value))
  }
  return (
    <div className={styles.editedUserDitails}>
      <p>Bitte geben Sie den Code ein, den Sie erhalten haben</p>
      <ConfirmCodeField
        verificationCode={verificationCode}
        errorMessage={errorMessage}
        setVerification={handleSetVerificationCode}
      />
      <Button
        primary
        onClick={handleSubmit}
        disabled={verificationCode.length !== 6}
      >
        Bestätigen
      </Button>
      <CountDown
        handleResendCode={handleResendCode}
        date={date}
        setDate={setDate}
        mlSeconds={mlSeconds}
        buttonText={'Bestätigungsmail erneut senden'}
      />
    </div>
  )
}

export default EnterCode
